import { instalacionHeroImage } from "@/mocks/serviceInstalacionData";

export default function InstallIntro() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="reveal order-2 lg:order-1">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-[#0087a4] mb-6 leading-tight">
              Servicio Profesional y Seguro para un Funcionamiento &Oacute;ptimo
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              La instalaci&oacute;n adecuada de un aire acondicionado garantiza su eficiencia, durabilidad y bajo consumo energ&eacute;tico. En{" "}
              <span className="text-[#0087a4] font-semibold">SERIN INGENIER&Iacute;A DE PROYECTOS SAS</span>, contamos con t&eacute;cnicos certificados para realizar instalaciones en hogares, oficinas, comercios e industrias.
            </p>
            <a
              href="https://wa.me/573232209100"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-7 py-3.5 rounded-lg bg-[#0087a4] text-white font-semibold text-sm md:text-base hover:bg-[#006f86] transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2" />
              M&aacute;s informaci&oacute;n
            </a>
          </div>

          <div className="reveal relative h-[300px] md:h-[400px] rounded-lg overflow-hidden order-1 lg:order-2">
            <img
              src={instalacionHeroImage}
              alt="Instalaci&oacute;n profesional de aire acondicionado"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}